import React, { useEffect, useState } from "react";
import NetaqInput from "./NetaqInput";
import ActionButton from "./ActionButton";
import { Link } from "react-router-dom";
import { useTranslate } from "./TranslationText";
import axiosInstance from "../axios/axios";

export default function LoginUaePassOTPForm({ onSubmit, setOTP, sendNewPassword, isRegisterPage = false, email, showSuccessmessage, showErrormessage, isProfilePage = false }) {
  const { translate } = useTranslate();
  const [password, setPassWord] = useState(null);
  const [newPassword, setNewPassword] = useState(null);
  const [error, setError] = useState(translate('web.passwordIsNotMatch', 'Password Is Not Match'));
  const [passwordMatch, setPasswordMatch] = useState(false);

  useEffect(() => {
    if ((password !== newPassword) && (!!password && !!newPassword)) {
      setPasswordMatch(false)
    } else {
      if ((password === newPassword) && (!!password && !!newPassword)) {
        setPasswordMatch(true);
        sendNewPassword(newPassword);
      } else {
        setPasswordMatch(false);
      }
    }
  }, [password, newPassword])

  const handleChange = (event, inputName) => {
    if (inputName == 'p1') {
      setPassWord(event.target.value)
      return;
    }
    if (inputName == 'p2') {
      setNewPassword(event.target.value)
    }
  }

  async function resendCode() {
    try {
      const res = await axiosInstance.post(isProfilePage ? 'account/resendOtpTempEmail' : `/account/resendotp?email=${email}`);
      if (res.data?.status?.responseCode == '200') {
        showSuccessmessage(
          translate('web.anEmailHasBeenSentToYourEmailWithOTP', 'An Email has been Sent to Your Email with OTP')
        );
      } else {
        showErrormessage(
          translate(res.data?.status?.detailedResponseCode, res.data?.status?.detailedResponseCode)
        )
      }
    } catch (error) {
      showErrormessage(error)
    }
  }

  return (
    <form className="rtl" onSubmit={onSubmit}
      style={{
        backgroundColor: "#F7F7F7",
        padding: 25,
        display: "flex",
        flexDirection: "column",
        position: 'fixed',
        top: '40%',
        left: 0,
        right: 0,
        width: '35%',
        margin: "auto",
        minheight: 250,
        minWidth: 301,
        zIndex: 1000

      }}
    >
      {isRegisterPage ?
        <>
          <NetaqInput
            name={"token"}
            label={translate('web.otp', 'OTP')}
            key={"OTP"}
            placeholder={"XXXXXX"}
            type={"text"}
            onChange={(event) => setOTP(event?.target?.value?.trim())}
          />
        </>

        : <>
          <NetaqInput
            name={"token"}
            label={translate('web.resetPasswordToken', 'Reset Password Token')}
            key={"OTP"}
            placeholder={"XXXXXX"}
            type={"text"}
            onChange={(event) => setOTP(event.target.value?.trim())}
          />
          <NetaqInput
            name={"password"}
            label={translate('web.newPassword', 'New Password')}
            key={"password"}
            placeholder={"*******"}
            type={"password"}
            onChange={(evt) => handleChange(evt, 'p1')}
          />
          <NetaqInput
            name={"newPassword"}
            label={translate('web.confirmNewPassword', 'Confirm New Password')}
            key={"newPassword"}
            placeholder={"*******"}
            type={"password"}
            onChange={(evt) => handleChange(evt, 'p2')}
          />

          {(password !== newPassword) && (!!password && !!newPassword) &&
            <div className="text-danger">
              {error}
            </div>
          }
        </>}

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        {isRegisterPage &&
          <div className="text-decoration-underline text-danger my-2" style={{ cursor: 'pointer' }} onClick={() => resendCode()}>{translate('web.resendCode', 'Resend Code')}</div>
        }

        {isRegisterPage ?
          <ActionButton
            margin={0}
            width={"100%"}
            key={"loginuaepass"}
            text={translate("web.submit", "Submit")}
            type={"submit"}
          /> :
          <ActionButton
            margin={5}
            width={"100%"}
            disabled={!passwordMatch}
            key={"loginuaepass"}
            text={translate("web.submit", "Submit")}
            type={"submit"}
          />
        }
      </div>
    </form>
  );
}
